import { render } from "./HomeVideo.vue?vue&type=template&id=10a68b99"
import script from "./HomeVideo.vue?vue&type=script&lang=js"
export * from "./HomeVideo.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__